import {
  mapMutations,
  mapState
} from 'vuex'
export default {
  data() {
    return {

    };
  },
  mounted() {

    //鼠标按下事件
    this.鼠标按下事件 = this.$vueEvent(this.$el, 'mousedown')
    //鼠标松开事件
    this.designerEventUpContainer = this.$vueEvent(this.$el, 'mouseup')
      .add(".goDetail", this.goDetail)
      .add(".buy_btn_f", this.openCart)
      .add(".buy_now", this.buyNow)
      .add(".addGoods", this.addGoods)
      .add(".catch", this.catch)
  },
  computed: {
    ...mapState('goods', {
      showBuyDrawer: 'showBuyDrawer',
    }),
  },
  created() {},
  destroyed() {
    this.鼠标按下事件.clear()
    this.designerEventUpContainer.clear()
  },
  methods: {
    ...mapMutations("designer", {


    }),
    ...mapMutations("goods", {
      updateBuyDrawer: 'updateBuyDrawer'
    }),
    // goDetail(e) {
    //   this.$router.push("detail")
    //   console.log("=====goDetail====")
    // },
    openCart(e) {
      // console.log("=====openBuy====")
      this.$router.push("cart")
    },
    buyNow(e) {
      // console.log("=====openBuy====")
      this.$router.push("order")
    },
    addGoods(e) {
      // console.log("=====openBuy====")
      this.$router.push("order")
    },
    catch () {
      return true
    },
    close() {
      // console.log("=====close====")


    },
  }
}



// WEBPACK FOOTER //
// ./src/mixin/mixin-home.js